import { ConsolidationMapTask } from "./ConsolidationMapTask";

/** @import { BvhNode } from "../../BvhNode" */

/**
 * Creates a task to compute the consolidation map
 *
 * @param {BvhNode} node - The ID of the BVH node
 * @param {Stage} stage - The stage of the task
 */
export function initializeConsolidationComputedTasks(node, stage) {
  if (!node.transparent) {
    node.addTask(new ConsolidationMapTask(node.outOfCoreTileManager, node.nodeId), stage);
  }
}